import React from 'react';

export const PageSpinner: React.FC = (): JSX.Element => {
    return <>
        <div className="spinner-border"/>
    </>;
};